import { createIcon } from '@/utils/factoryUtil'

export const SVGTypeLand = createIcon('SVGTypeLand', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M36.51,88.9c-13.68-1.32-27.13-4.83-32.76-8.56-5.91-3.91-4.99-7.99,3.88-17.38,7.97-8.43,11.63-15.49,16.8-32.38,3.4-11.09,6.53-18.07,8.65-19.24,3.27-1.82,5.53.81,9.86,11.49,4.6,11.35,8.55,18.23,13.42,23.41,1.47,1.56,2.9,2.63,3.53,2.63,1.25,0,3.07-2.18,6.34-7.58,2.65-4.37,4.68-5.75,7.76-5.27,2.86.45,5.01,3.28,7.55,9.93,1.19,3.12,2.9,7.14,3.79,8.93,1.68,3.36,5.95,9.51,6.62,9.52.77.02,6.52,5.8,7.32,7.35,2.41,4.69-1.15,8.83-10.25,11.94-10.94,3.73-20.82,5.23-36.25,5.48-6.33.1-13.65-.02-16.26-.27Z' />
  </svg>
))
